
import { AdsCampaign   }  from './types';


/*
export const checkDate = ( dateStr: string ): Validation => {

  var result: Validation = {
    code:    1 ,
    comment: ""  
  };

  if ( dateStr === '' )
        {
         result.code    = -1;
         result.comment = "Il manque la date.";  
        }
   else {
	     if ( isValidDate = ( dateStr , 'dd/MM/yyyy HH:mm' ) === false )
		  {
           result.code    = -2;
           result.comment = "La date saisie n'est pas valide.";  
		  }
        }
		  
  return result;
};
*/
export const compareAdsCampaign = ( campaignA      : AdsCampaign  , 
									  nameB          : string         , 
									  beginningDateB : Date | null    , 
									  endingDateB    : Date | null    ) : boolean => {

  const result = ( campaignA.name          === nameB          ) && 
                 ( campaignA.beginningDate === beginningDateB ) && 
                 ( campaignA.endingDate    === endingDateB    ) 
																		   

  return result																			   
}
